import React from 'react';
import Form from '../../components/Form';
import ContactSection from '../../components/ContactSection';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

interface TransitVisaProps {}

const TransitVisa: React.FC<TransitVisaProps> = (props) => {
    const { t } = useTranslation(); // useTranslation hook'unu kullanarak 't' fonksiyonuna eriş
    return (
        <>
            <Helmet>
                <title>{t('transitVisa')}</title>
                <meta name="keywords" content="Cezayir Transit Vize" />
            </Helmet>
            <section className='breadbrumb-section'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12 breadcrumb-container'>
                            <h1>{t('transitVisa')}</h1>
                            <ul className="breadcrumbs">
                                <li><a href="/">{t('home')}</a></li>
                                <li>{t('transitVisa')}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className='content-style-01 py-5 my-5'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <h5>{t('applicationProcess')}</h5>
                            <h2>{t('whatIsATransitVisa')}</h2>
                        <p>
                        {t('transitTexts.p1')}
                                                    </p>
<h3 className='mb-4'>{t('transitTexts.h3')}</h3>
<ul>
    <li>
    {t('transitTexts.p2')}
</li>
<li>
{t('transitTexts.p3')}

</li>
</ul>

                        </div>
                    </div>
                </div>
            </section>

            <section className='form-section mb-5'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='content-style-01'>
                            <h5>{t('haveAQuestion')}</h5>
                            <h2>{t('writeToUs')}</h2>
                            </div>
                            <Form />
                        </div>
                    </div>
                </div>
            </section>

            <ContactSection />
        </>
    );
}

export default TransitVisa;